import { ArrowDown } from 'lucide-react'
import styles from './JumpToPresent.module.css'

/** Кнопка поверх ленты, когда на экране старые сообщения после перехода по ссылке или из поиска. */
export function JumpToPresent({ onClick, disabled = false }: { onClick: () => void; disabled?: boolean }) {
  return (
    <div className={styles.bar} role="status">
      <button type="button" className={styles.button} onClick={onClick} disabled={disabled} aria-label="К новым сообщениям" data-tooltip="К новым сообщениям">
        <span className={styles.label}>К новым сообщениям</span> <ArrowDown size={16} />
      </button>
    </div>
  )
}
